import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null
  },
  mutations: {
    saveUser (state, user) {
      state.user = user
    },
    setToken (state, token) {
      state.token = token
    },
    cleanToken (state) {
      state.token = null
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js